angular
	.module 'App.Component'
	.component 'backgroundProcess',
		{
			templateUrl: '@component/background-process/background-process.view.html'
			controller: 'BackgroundProcessComponent'
			controllerAs: 'backgroundProcess'
			bindings:
				buttonClass: '@'
				buttonText: '@'
				typeId: '@'
				format: '@'
				isReport: '@?'
				email: '<'
				filter: '<'
				clickFilter: '<?'
				disabled: '<?'
		}

class BackgroundProcessComponent extends AbstractController
	@registerController()
	@inject '$sce',
		'$rootScope'
		'translate'
		'BackgroundProcessService'
		'MessageTerminal'
		'ToastService'

	initialize: ->
		@isReport ?= true
		@disabled ?= false
		@clickFilter ?= {}

		@MessageTerminal.on @$rootScope, @MessageTerminal.events.BACKGROUND_PROCESS.COMPLETE,
			(task) =>
				return if task.report.type != @typeId || !@isLoading

				@isLoading = false
				@ToastService.add(
					@translate('background.process.download'),
					null,
					@translate('general.success'),
					'success'
				)

				if @isReport
					@ToastService.add(
						@translate('general.report.download'),
						@translate('general.report'),
						@translate('general.info'),
						'info'
					)

		@MessageTerminal.on @$rootScope, @MessageTerminal.events.BACKGROUND_PROCESS.ERROR,
			(typeId, task, response) =>
				if typeId != @typeId || !@isLoading
					return

				@isLoading = false
				@ToastService.add "#{@typeId}: failed to generate report. #{response || ''}",
					'Background Download',
					'error',
					'error'

	$onChanges: ->
		@titleHtml = @$sce.trustAsHtml(@buttonText)

	start: ->
		if @isLoading || @disabled
			return

		@isLoading = true

		if @filter instanceof FilterDTO
			@filter = @filter.getFilter()

		filter = _.extend {}, @filter, @clickFilter

		@BackgroundProcessService.init @typeId, filter, @format, @email
